import { memo } from "react";
import { Box, Modal } from "@mui/material";

import { GreenTick } from "@zenith/assets/icons/components";
import { ButtonComponent } from "@zenith/components";

export interface TeamMemberSuccessModalProps {
  showModal: boolean;
  /** Node 56507:28206 — a default password was set, so the member is ACTIVE
   * immediately rather than PENDING on an emailed invite, and the screen
   * says so instead of "Invitation sent". */
  passwordCreated: boolean;
  onDone: () => void;
}

const TeamMemberSuccessModal = memo(function TeamMemberSuccessModal(
  props: TeamMemberSuccessModalProps
) {
  const { showModal, passwordCreated, onDone } = props;

  return (
    <Modal open={showModal} onClose={onDone} className="overflow-visible">
      <Box className="absolute left-1/2 top-1/2 z-0 flex w-[95%] max-w-[500px] -translate-x-1/2 -translate-y-1/2 transform flex-col items-center rounded-xl bg-white p-10 text-center outline-none">
        <GreenTick width={64} height={64} />
        <h2 className="mb-2 mt-4 text-2xl font-semibold text-neutral-900">
          {passwordCreated ? "Team Member Added" : "Invitation sent"}
        </h2>
        <p className="mb-8 text-sm text-neutral-600">
          {passwordCreated
            ? "Your team member has been added successfully."
            : "Your invitation to team member has been sent."}
        </p>
        <ButtonComponent
          id="team-member-success-done"
          type="primary"
          size="large"
          label="Go to team management"
          className="w-full"
          onClick={onDone}
        />
      </Box>
    </Modal>
  );
});

export default TeamMemberSuccessModal;
